export function findByKey(arr, key) {
  if (!arr) return undefined
  for (const item of arr) {
    if (item.value === key) {
      return item.text
    }
  }
  return undefined
}
